import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {Icon} from 'front-onceforall-core';
import {Tooltip} from '@material-ui/core';
import {DOCUMENT_STATE} from 'front-onceforall-core/dist/utils/documents';
import authenticationService from '../../services/authentication/AuthenticationService';
import documentService from '../../services/document/DocumentService';
import {openOrSaveFile} from '../../utils/http';
import DocumentState from '../document/DocumentState';
import {PROJECT_STATUS, CCRD_SUBTYPE, CRSE_SUBTYPE, projectType, MANAGE_PROJECT_PERMISSION} from '../../utils/constant';

export function ProjectSharedDocuments(props) {
  const canManageProject = authenticationService.roles().hasPermission(MANAGE_PROJECT_PERMISSION);

  function handleDownloadDocument(uid) {
    authenticationService.authRedirect(documentService.getFileUrl(uid))
      .then(authUrl => openOrSaveFile(authUrl));
  }

  function handleUploadDocument(document) {
    props.onUploadProjectSharedDocument(document);
  }

  const isProjectActive = props.projectStatus === PROJECT_STATUS.ACTIVE;
  const isProjectOwner = props.organisationId === props.projectOwnerId;
  const notConsultant = !authenticationService.roles().isConsultant();
  const isNominativeProject = props.projectType === projectType.NOMINATIVE;
  const CCRDExists = props.documents.some(document => document.type.code === CCRD_SUBTYPE);
  const CRSEExists = props.documents.some(document => document.type.code === CRSE_SUBTYPE);
  const showAddSpecButton = isNominativeProject && isProjectActive && isProjectOwner && canManageProject && !CCRDExists;
  const showAddRSEButton = isNominativeProject && isProjectActive && isProjectOwner && canManageProject && !CRSEExists;

  const documents = props.documents.map((document, index) => {
    const documentName = document.type.code.startsWith('GENERIC_PROJECT_SHARED_') ? document.additionalDesignation : document.type.name;

    return (
      <div
        key={`banette-doc-${index}`}
        data-id={`banette-doc-${index}`}
        className="box flex-container space-between mb-3"
      >
        <div className="flex-container column">
          <div data-id={`document-${index}-name`}>{documentName}</div>
          {isProjectOwner &&
            <div
              className="mt-2"
              style={{fontSize: 13}}
            >
              <DocumentState state={document.state}/>
            </div>
          }
        </div>
        <div className="flex-container">
          {document.hasFile &&
            <button
              className="small secondary"
              onClick={() => handleDownloadDocument(document.uid)}
              data-id={`banette-doc-${index}-download-button`}
            >
              <Icon icon="download"/>
            </button>
          }
          {isProjectOwner && notConsultant && document.state !== DOCUMENT_STATE.AWAITING_VALIDATION &&
            <button
              className="small secondary"
              onClick={() => handleUploadDocument(document)}
              data-id={`banette-doc-${index}-upload-button`}
            >
              <Icon icon="upload-document"/>
            </button>
          }
        </div>
      </div>
    );
  });

  return (
    <div className="card">
      <div className="card-header">
        <div className="card-title flex-container">
          <Translate value="banette.widgetTitle"/>
          <Tooltip title={<Translate value="banette.explanatoryTooltip"/>}>
            <span className="flex-container">
              <Icon
                icon="question-mark"
                size={18}
              />
            </span>
          </Tooltip>
        </div>
        {isProjectOwner && isProjectActive && canManageProject &&
        <Tooltip title={<Translate value="banette.uploadNewDocument"/>}>
          <button
            data-id="addProjectSharedDocumentButton"
            className="primary small inline-container"
            onClick={props.onAddProjectSharedDocument}
          >
            <Icon icon="plus"/>
          </button>
        </Tooltip>
        }
      </div>
      <div className="flex-container column">
        {props.loading && <span className="loading-overlay"/>}
        {showAddSpecButton &&
        <button
          data-id="require-spec-button"
          className="secondary large mb-3"
          onClick={() => props.onRequireProjectSpecificDocument('INS_DEC_NOMINATIVE')}
        >
          <Translate value="banette.requireCCRD"/>
        </button>
        }
        {showAddRSEButton &&
        <button
          data-id="require-rse-button"
          className="secondary large mb-3"
          onClick={() => props.onRequireProjectSpecificDocument('ADD_CHARTE_RSE')}
        >
          <Translate value="banette.requireCRSE"/>
        </button>
        }
        {documents.length > 0 ?
          documents :
          <div
            className="mt-5"
            style={{textAlign: 'center'}}
          >
            <Translate
              value="banette.noDocument"
              tag="div"
            />
            {isProjectOwner && canManageProject &&
            <Translate
              value="banette.pleaseAddDocument"
              tag="div"
            />
            }
          </div>
        }
      </div>
    </div>
  );
}

ProjectSharedDocuments.defaultProps = {
  documents: []
};

ProjectSharedDocuments.propTypes = {
  documents: PropTypes.array,
  onAddProjectSharedDocument: PropTypes.func.isRequired,
  onUploadProjectSharedDocument: PropTypes.func.isRequired,
  onRequireProjectSpecificDocument: PropTypes.func.isRequired,
  organisationId: PropTypes.number.isRequired,
  projectOwnerId: PropTypes.number.isRequired,
  projectStatus: PropTypes.string.isRequired,
  projectType: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired
};

export default ProjectSharedDocuments;
